import { render, staticRenderFns } from "./loginAndRegister.vue?vue&type=template&id=1628cf68&scoped=true"
import script from "./loginAndRegister.vue?vue&type=script&lang=js"
export * from "./loginAndRegister.vue?vue&type=script&lang=js"
import style0 from "./loginAndRegister.vue?vue&type=style&index=0&id=1628cf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1628cf68",
  null
  
)

export default component.exports